import React, { useMemo } from 'react';
import objectPath from 'object-path';
import { Auth } from 'aws-amplify';
import { useHistory } from 'react-router-dom';
import { connect, shallowEqual, useDispatch, useSelector } from 'react-redux';
import { toAbsoluteUrl } from '../../../_helpers';
import { useHtmlClassService } from '../../_core/MetronicLayout';
import { QuickUserToggler } from '../extras/QuiclUserToggler';
import UserNotificationsDropdown from '../extras/dropdowns/UserNotificationsDropdown';
import * as auth from '../../../../app/modules/Auth/_redux/authRedux';

function Topbar({ setUser }) {
  const uiService = useHtmlClassService();
  const history = useHistory();
  const dispatch = useDispatch();
  const user = useSelector(({ auth }) => auth.user, shallowEqual);
  const layoutProps = useMemo(() => {
    return {
      viewSearchDisplay: objectPath.get(
        uiService.config,
        'extras.search.display'
      ),
      viewNotificationsDisplay: objectPath.get(
        uiService.config,
        'extras.notifications.display'
      ),
      viewQuickActionsDisplay: objectPath.get(
        uiService.config,
        'extras.quick-actions.display'
      ),
      viewCartDisplay: objectPath.get(uiService.config, 'extras.cart.display'),
      viewQuickPanelDisplay: objectPath.get(
        uiService.config,
        'extras.quick-panel.display'
      ),
      viewLanguagesDisplay: objectPath.get(
        uiService.config,
        'extras.languages.display'
      ),
      viewUserDisplay: objectPath.get(uiService.config, 'extras.user.display'),
    };
  }, [uiService]);

  async function stopImpersonation() {
    const user = await Auth.currentAuthenticatedUser();
    await Auth.updateUserAttributes(user, {
      'custom:impersonating_user': '',
    });
    await Auth.currentSession();
    const originalUser = JSON.parse(localStorage.getItem('original_user'));
    dispatch(setUser(originalUser));
    localStorage.removeItem('original_user');
    history.push('/');
  }

  return (
    <div className="topbar">
      {!!user?.impersonating && (
        <div
          className="d-flex align-items-center mr-2 cursor-pointer"
          onClick={stopImpersonation}
        >
          <img
            alt="end-support"
            src={toAbsoluteUrl('/media/svg/senseworks/end-support.svg')}
          />
        </div>
      )}
      <UserNotificationsDropdown />

      {layoutProps.viewUserDisplay && <QuickUserToggler />}
    </div>
  );
}

export default connect(null, auth.actions)(Topbar);
